import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AddJob from "./components/AddJob";
import Jobs from "./components/Jobs/Jobs.jsx";
import Layout from "./components/Layout";
import EditJob from "./components/EditJob/EditJob";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Jobs />} />
          <Route
            path="*"
            element={<h1 style={{ color: "white" }}>404 Not Found</h1>}
          />
          <Route path="/add-job" element={<AddJob />} />
          <Route path="/edit-job/:id" element={<EditJob />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
